import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-money",
  "use": "icon-money-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-money\"><path d=\"M432.8 1022.928V793.581H60.08v-95.465H432.8v-99.16H60.08V496.119h303.9L.792.208h180.726L441.86 360.622c28.925 41.135 51.5 76.856 67.869 107.036 14.298-24.39 39.104-62.207 74.377-113.442L831.102.208h192.002L658.812 496.11h306.595v102.855H594.278v99.16h371.13v95.456h-371.13v229.347h-161.47z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol